/**
 * Customer-facing copy shared by more than one surface.
 *
 * This sentence exists in several variants across the app, differing in whether
 * they carry a support number and whether it is a link. They are not
 * interchangeable: the one below is the transient-API-failure message, shown
 * where pressing Continue again is the way to retry, and it deliberately has no
 * support number — there is nothing for the customer to phone about. The
 * variant that does carry one belongs to the page-load eligibility failure,
 * which the customer cannot retry their way out of.
 *
 * Kept here so the two surfaces that must say the same thing cannot drift.
 */
export const TEMPORARY_TECHNICAL_ERROR =
  'We’re sorry. There was a temporary technical error. Please try again shortly.';
